import { IButtonWithBadge } from "@mctypes/frontend.types";
import { IMinProject } from "@mctypes/global.types";
import { IIssueBoardApi } from "@schemas/issueBoardSchema";
import { IIssueApi } from "@schemas/issueSchema";
import React from "react";
import ButtonGroupWithBadgeDeprecated from "../../../../../../components/ButtonGroupWithBadge/ButtonGroupWithBadge";
import { useGetFilesFromAzureBlobStorageQuery } from "../../../../../azureBlobStorageRTK";
import { getIssueActionNameOption, getTaskCompleteCount } from "../../../issueUtils";

const IssueItemButtonGroupsDeprecated: React.FC<{
  issue: IIssueApi;
  activeButtonName: string;
  setSelectedButtonName;
  taskOrIssue: string;
  projectIsGisActivated: boolean;
  issueBoard: IIssueBoardApi;
}> = ({ issue, activeButtonName, setSelectedButtonName, taskOrIssue, projectIsGisActivated, issueBoard }) => {
  const project = issue?.project as IMinProject;
  const projectId = project?._id || (project as string);
  const path = `${projectId}/issue/${issue?._id}/files`;

  const {
    data: files,
    isLoading: loadingFiles,
    isError: errorFetchingFiles,
  } = useGetFilesFromAzureBlobStorageQuery({ projectId, path }, { skip: projectId == null });

  const buttons: IButtonWithBadge[] = [
    {
      name: "Info",
      value: "Info",
    },
  ];

  if (taskOrIssue === "ISSUE") {
    buttons.push({
      name: getIssueActionNameOption(issueBoard?.taskNameSetting, "plural"),
      value: "Actions",
      taskCompleteCount: getTaskCompleteCount(issue),
    });
  }
  buttons.push({
    name: "Filer",
    value: "Filer",
    badgeCount: files?.length || 0,
  });

  if (projectIsGisActivated) {
    /* buttons.push({
      name: "GIS",
      badgeIcon: hasIssueGisConnection(issue) ? "fa-globe" : null,
    });*/
    buttons.push({
      name: "Logg",
      value: "Logg",
    });
  } else {
    buttons.push({ name: "Logg", value: "Logg" });
  }

  return (
    <ButtonGroupWithBadgeDeprecated
      buttons={buttons}
      activeButtonName={activeButtonName}
      setSelectedButtonName={setSelectedButtonName}
      className="w-100 mr-2"
      style={{ height: "2.2rem" }}
    />
  );
};

export default IssueItemButtonGroupsDeprecated;
